import { render } from "./ClientComprasOrdenes.vue?vue&type=template&id=8ed8ab30&scoped=true"
import script from "./ClientComprasOrdenes.vue?vue&type=script&lang=js"
export * from "./ClientComprasOrdenes.vue?vue&type=script&lang=js"

import "./ClientComprasOrdenes.vue?vue&type=style&index=0&id=8ed8ab30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ed8ab30"]])

export default __exports__